// API 설정
export const getApiUrl = () => {
  // 개발 환경 - 로컬 프록시 서버 사용
  if (process.env.NODE_ENV === 'development') {
    const hostname = window.location.hostname;
    return `http://${hostname}:3001`;
  }

  // 프로덕션 환경 - Vercel Serverless Functions 사용
  return '';
};

export const API_BASE_URL = getApiUrl();
